import { render, staticRenderFns } from "./wang.vue?vue&type=template&id=edaa5daa&lang=html&"
import script from "./wang.vue?vue&type=script&lang=js&"
export * from "./wang.vue?vue&type=script&lang=js&"
import style0 from "./wang.vue?vue&type=style&index=0&id=edaa5daa&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.10.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports